<template>
  <div v-if="false">
  </div>
</template>

<script>

export default {
  name: 'HomeView',
    data() {
        return {
            lastHistoryPosition: false
        }
    },
    mounted () {
        this.lastHistoryPosition = history.state?.position ?? 0;
    },
    beforeRouteLeave (/* to, from */) {
        const currentPosition = history.state?.position ?? 0;
        if(currentPosition >= this.lastHistoryPosition) { return true } // not going back
        if(!this.$root.$refs.home.close()) {
          return false
        }
    }
}
</script>